/* tslint:disable */
/* eslint-disable */
/**
 * ANEP Device Provisioning API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  HTTPValidationError,
} from '../models/index';
import {
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
} from '../models/index';

export interface Apiv2GetRegistryByphoneV2RegistryLookupphonePhoneGetRequest {
    phone: string;
}

export interface Apiv2GetRegistryV2RegistryDeviceIdGetRequest {
    deviceId: string;
}

/**
 * 
 */
export class RegistryOauthApi extends runtime.BaseAPI {

    /**
     * Permet de récupérer la configuration d\'un équipement à partir de son numéro de téléphone.  Format E.164 : 33612345678 Pas d\'API v1
     * Apiv2 Get Registry Byphone
     */
    async apiv2GetRegistryByphoneV2RegistryLookupphonePhoneGetRaw(requestParameters: Apiv2GetRegistryByphoneV2RegistryLookupphonePhoneGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters['phone'] == null) {
            throw new runtime.RequiredError(
                'phone',
                'Required parameter "phone" was null or undefined when calling apiv2GetRegistryByphoneV2RegistryLookupphonePhoneGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2AuthorizationCodeBearer", []);
        }


        let urlPath = `/v2/registry/lookupphone/{phone}`;
        urlPath = urlPath.replace(`{${"phone"}}`, encodeURIComponent(String(requestParameters['phone'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Permet de récupérer la configuration d\'un équipement à partir de son numéro de téléphone.  Format E.164 : 33612345678 Pas d\'API v1
     * Apiv2 Get Registry Byphone
     */
    async apiv2GetRegistryByphoneV2RegistryLookupphonePhoneGet(requestParameters: Apiv2GetRegistryByphoneV2RegistryLookupphonePhoneGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.apiv2GetRegistryByphoneV2RegistryLookupphonePhoneGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Permet de récupérer la configuration d\'un équipement. Pas de v1
     * Apiv2 Get Registry
     */
    async apiv2GetRegistryV2RegistryDeviceIdGetRaw(requestParameters: Apiv2GetRegistryV2RegistryDeviceIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters['deviceId'] == null) {
            throw new runtime.RequiredError(
                'deviceId',
                'Required parameter "deviceId" was null or undefined when calling apiv2GetRegistryV2RegistryDeviceIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2AuthorizationCodeBearer", []);
        }


        let urlPath = `/v2/registry/{device_id}`;
        urlPath = urlPath.replace(`{${"device_id"}}`, encodeURIComponent(String(requestParameters['deviceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Permet de récupérer la configuration d\'un équipement. Pas de v1
     * Apiv2 Get Registry
     */
    async apiv2GetRegistryV2RegistryDeviceIdGet(requestParameters: Apiv2GetRegistryV2RegistryDeviceIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.apiv2GetRegistryV2RegistryDeviceIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
